export default __webpack_public_path__ + "svg/ceo/financing.svg?9383d361";